module.exports = __webpack_public_path__ + "img/stormcraft.0400325a.svg";